import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../core/shared/menu-items/menu-items';
import { TranslationService } from '../../../core/services/translation/translation.service';
import { Router } from '@angular/router';
import { AgenceService } from '../../../core/services/agence/agence.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { UserService } from '../../../core/services/user/user.service';
import { UserOptions } from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { CollisService } from '../../../core/services/collis/collis.service';
import { HttpClient } from '@angular/common/http';
import { ColissessionService } from '../../../core/services/colissession/colissession.service';
import { DatePipe } from '@angular/common';
import { BagageService } from '../../../core/services/bagage/bagage.service';
import { RecetteService } from '../../../core/services/recette/recette.service';
import { MenuItemsGuichet } from '../../../core/shared/menu-items/menu-item-guichet';
import { MenuItemsEnvoi } from 'src/app/core/shared/menu-items/menu-item-envoi';
import { MenuItemsChef } from '../../../core/shared/menu-items/menu-item-chef';
import { MenuItemsRetrait } from 'src/app/core/shared/menu-items/menu-item-retrait';
import { VoyageService } from '../../../core/services/voyage/voyage.service';
import { ProfileComponent } from 'src/app/module/account/profile/profile.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy, OnInit {
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;
  userinfo: any;
  userprivileges: any;
  picture: any;
  collis: any;
  base64: any;
  sessiondetail: any;
  name: string;
  depense: any;
  pageheight: any;
  recette: any;
  bagage: any;
  section: any;
  ispopup: boolean;
  pageHeights3: any;
  pageHeights2: any;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,private dialog: MatDialog,
    private media: MediaMatcher, private translationservice: TranslationService,
    public menuItems: MenuItems, public menuItems2: MenuItemsGuichet, public menuItems3: MenuItemsEnvoi ,
    public menuItems4: MenuItemsChef, public menuItems5: MenuItemsRetrait,private router: Router,
    private agenceservice: AgenceService, private bnIdle: BnNgIdleService, private userservice: UserService,
    private collisservice: CollisService, private http: HttpClient, private sessionservice: ColissessionService,
     private datepipe: DatePipe, private bagageservice: BagageService, private recetteservice: RecetteService,
     private voaygeservice: VoyageService
  ) {
    this.section = localStorage.getItem('section');
    this.getuserinfo();
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.userprivileges = localStorage.getItem('authority');
    this.userprivileges = JSON.parse(this.userprivileges);
    // console.log(this.userprivileges);
    let personid: any = localStorage.getItem('userinfo');
    personid = JSON.parse(personid);
    this.name = personid[0].nom + ' ' + personid[0].prenom;
    this.picture = personid[0].profile;
    this.ispopup = false;
  }
  ngOnInit(): void {
    this.getuserinfo();
    this.getlogo();
    // this.bnIdle.startWatching(60).subscribe((isTimedOut: boolean) => {
      // if (isTimedOut) {
        // console.log('session expired');
    //   }
    // });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  // increase() {
  //   this.sidenavWidth = 15;
  //   console.log('increase sidenav width');
  // }
  // decrease() {
  //   this.sidenavWidth = 4;
  //   console.log('decrease sidenav width');
  // }

  viewProfil(): any {

    this.ispopup = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    // dialogConfig.position={
    //   right:'110px',
    // };
    dialogConfig.data = {};
    const dialogref = this.dialog.open(ProfileComponent , {
      width: 'auto', height: 'auto', autoFocus: true, disableClose: dialogConfig.disableClose, data: {}
    });
  }

  logout(): void{
    localStorage.removeItem('userinfo');
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    localStorage.removeItem('agenceinso');
    localStorage.removeItem('agence');
    localStorage.removeItem('session');
    localStorage.removeItem('authority');
    localStorage.removeItem('lastprint');
    localStorage.removeItem('voyage');
    this.router.navigateByUrl('login');
    localStorage.removeItem('voyage');
  }

  closesession(): void {
    let personid: any = localStorage.getItem('userinfo');
    personid = JSON.parse(personid);
    const sessionid = '';
    const session = localStorage.getItem('session');

    this.userservice.updateusersession(personid[0].idpersonnel, sessionid, session).subscribe((response: any) => {
      // console.log(response);
      this.getsessioninfoBeforeCloseSession(session);

    });
  }

  getuserinfo(): any {
    this.userinfo = localStorage.getItem('userinfo');
    this.userinfo = JSON.parse(this.userinfo);
    this.userinfo = this.userinfo[0];
    localStorage.setItem('agence', this.userinfo?.idagence);
    this.getagenceinfo();
  }

  getagenceinfo(): any {
    this.agenceservice.getagenceinfo(localStorage.getItem('agence')).subscribe((response: any) => {
      // console.log('response', response);
      const agenceinfo = JSON.stringify(response);
      localStorage.setItem('agenceinso',agenceinfo);
    });
  }

  decodeuri(uri: string): string {
    return decodeURIComponent(uri);
  }

  async print(session: any): Promise<any> {
    // console.log(session);
    const page = 0; const size = 10000;
    await this.collisservice.getallcollisinSession(session, page, size).subscribe((collis: any) => {
      // console.log("collis", collis.content);
      this.collis = collis.content;
      // console.log("collis", this.collis);

      let doc: any;
      const datas = collis.content;
      // console.log('length ', data);
      let heightdoc = 0.3 * (datas?.length - 2);


      if(this.collis?.length < 4){
          heightdoc = 0;
        }
        // console.log('height doc ', heightdoc);
        // var doc = new jsPDF('l', 'in', [(3+heightdoc), 8.25]) as jsPDFWithPlugin;
      // doc = new jsPDF('p', 'in', [(8.27),(11.69)]) as jsPDFWithPlugin;
      doc = new jsPDF(this.collis?.length > 23 ? 'p' : 'l', 'in', [( 3 + heightdoc), 8.25]) as jsPDFWithPlugin;

      const content: any = [];
      for (let i = 0; i < datas.length; i++){
        const rowdata = [];
        // console.log('Content', data[i]);
        for (let index = 0; index < datas.length; index++) {
            rowdata.push((i + 1), datas[i].ticket, datas[i].descriptioncollis, datas[i].sender.name, datas[i].receiver[0].name, datas[i].receiver[0].primarynumber, datas[i].tarif, datas[i].creationdate);
          }
        content.push(rowdata);
      }
      // console.log('Content2', content);
      // content.forEach((element: any) => {
      //   console.log('element ', element);
      // });
      doc.setFontSize(12);
      doc.setFont('Arial', 'bold');
      doc.text('GENERAL EXPRESS VOYAGES', 3, 0.27);
      // doc.text('GENERAL EXPRESS VOYAGES', data.settings.margin.left, 22);
      doc.setFontSize(12);
      doc.setFont('Arial', 'bold');
      doc.text('RAPPORT DE SESSION #' + this.sessiondetail?.idsessiion + '/' + this.sessiondetail?.sessionCount, 0.3, 0.4);
      doc.setFontSize(10);
      // doc.setTextColor(100);
      doc.setFont('Arial', 'bold');
      doc.text('RAPPORT DE SESSION #' + this.sessiondetail?.idsessiion + '/' + this.sessiondetail?.sessionCount, 0.3, 0.4);
      doc.setFontSize(8);
      // doc.setTextColor(100);
      doc.setFont('Arial', 'bold');
      doc.text('Agent:  ' + this.name, 0.6, 0.6);
      doc.text('S/N:  ' + this.sessiondetail?.idsessiion, 0.6, 0.8);
      doc.text('Montant:  ' + this.sessiondetail?.sessionAmount + ' FCFA', 0.6, 1);
      doc.text('Date Ouverture S/N:  ' + this.datepipe.transform(this.sessiondetail?.creationDate, 'yyyy-MM-dd HH:mm:ss') , 3, 0.8);
      doc.text('Date Fermeture S/N:  ' + this.datepipe.transform(this.sessiondetail?.closingDate, 'yyyy-MM-dd HH:mm:ss') , 3, 1);
      doc.text('Date:  ' + this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss') , 3, 0.6);
      // doc.text('Motoboy:  ' + this.bordereauinfo.motoboy.nommb, 5, 0.72);

      const base64Img = this.base64;

      if (base64Img) {
        doc.addImage(this.base64, 'JPEG', 6.7, 0, 1, 1);
      }

      doc.autoTable({
        head: [['#', 'N°', 'Nature du Colis', 'Expéditeur', 'Destinataire', 'Telephone', 'Prix', 'Date']],
        body: content,
        showHead: 'firstPage',
        startY: 1.05,
        pageBreak: 'auto',
        rowPageBreak: 'auto',
        theme: 'plain',
        headStyles: {
          fontSize: 12,
          fillColor: '#ffffff',
          fontStyle: 'bold',
          font: 'Arial',
          lineWidth: 0.01,
          lineColor: '#000000',
        },
        styles: {
          overflow: 'ellipsize',
          fontSize: 10,
          font: 'Arial',
          lineWidth: 0.01,
          lineColor: '#000000',
          textColor : '#000000',
        },
        didDrawPage: (data: any) => {
          // Header

          doc.setFontSize(20);
          doc.setTextColor(40);
          // const base64Img = 'data:image/jpeg;base64,' + btoa('../../../../assets/images/logogen.jpg');
          // const base64Img = this.base64;

          // if (base64Img) {
          //   doc.addImage(this.base64, 'JPEG', 6.7, 0, 1, 1);
          // }
          // doc.text('Report', data.settings.margin.left + 15, 22)

          // Footer
          doc.setFontSize(11);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          const pageCount = doc.internal.getNumberOfPages();
          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          // doc.text('Visa Agent', data.settings.margin.left, pageHeight);
          if (doc.internal.getCurrentPageInfo().pageNumber == pageCount) {
            doc.text('TOTAL MONTANT: ' + this.sessiondetail?.sessionAmount + ' FCFA', data.settings.margin.right + 2, (pageHeight - 0.7), {align: 'center'});
            doc.setFontSize(10);
            doc.text('Visa Agent', data.settings.margin.right + 2, (pageHeight - 0.5));
            doc.text('Visa du Chef', data.settings.margin.right + 4, (pageHeight - 0.5));
          }
        },
        drawRow: (row: any) => {
          if (row.index > 0 && row.index % 23 === 0) {
             doc.autoTableAddPage();
             doc = new jsPDF(this.collis?.length > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
           }
         }
      });
      // doc.save('table.pdf');

      doc.autoPrint();
      //This is a key for printing
      doc.output('dataurlnewwindow');
      //end print
    });
    setTimeout(() => {
      // this.print(session);
      localStorage.removeItem('userinfo');
      localStorage.removeItem('token');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('userRole');
      localStorage.removeItem('agenceinso');
      localStorage.removeItem('agence');
      localStorage.removeItem('session');
      localStorage.removeItem('authority');
      localStorage.removeItem('lastprint');
      localStorage.removeItem('section');
      this.router.navigateByUrl('login');
    }, 300);
  }

  async getlogo(): Promise<any>{
    await this.http.get('../../../../assets/images/logogen.jpg', { responseType: 'blob' })
      .subscribe((res: any) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          var base64data = reader.result;
          // console.log(base64data);
          this.base64 = base64data;
        };

        reader.readAsDataURL(res);
        // console.log(res);
      });
  }

  getsessioninfo(session: any): any {
    this.sessionservice.getsessiondetail(session).subscribe((response: any) => {
      this.sessiondetail = response;
      // console.log('session ', this.sessiondetail);
    });
  }

  getsessioninfoBeforeCloseSession(session: any): any {
    this.sessionservice.getsessiondetail(session).subscribe((response: any) => {
      this.sessiondetail = response;
      // console.log('session ', this.sessiondetail);
      setTimeout(() => {
        if(localStorage.getItem('section') == 'envoi'){
          // this.print2(session);
          this.getCollisSessionSummary(session);
        }
        if(localStorage.getItem('section') == 'guichet'){
          this.getpassagerSessionSummary(session);
        }
          if(localStorage.getItem('section') != 'guichet' && localStorage.getItem('section') != 'envoi'){
            setTimeout(() => {
              localStorage.removeItem('userinfo');
              localStorage.removeItem('token');
              localStorage.removeItem('loggedInUser');
              localStorage.removeItem('userRole');
              localStorage.removeItem('agenceinso');
              localStorage.removeItem('agence');
              localStorage.removeItem('authority');
              localStorage.removeItem('section');
              localStorage.removeItem('lastprint');
              localStorage.removeItem('voyage');
              this.router.navigateByUrl('login');
              localStorage.removeItem('session');
              localStorage.clear();
              }, 700);
          }
        }, 500);
    });
  }

  async print2(session: any): Promise<any> {
    // console.log(datas);
    const page = 0; const size = 1000;
    await this.collisservice.getallcollisinSession(session, page, size).subscribe((collis: any) => {
      // console.log("collis", collis.content);
      this.collis = collis.content;
      // console.log("collis", this.collis);

      let doc: any;
      // collis
      const data = collis.content;
      this.bagageservice.getallbagageinSession(session, page, size).subscribe((bagage: any) => {
        this.bagage = bagage.content;

        this.recetteservice.getallrecetteinSession(session, page, size).subscribe((recette: any) => {
          this.recette = recette.content;

          this.recetteservice.getalldepenseinSession(session, page, size).subscribe((depense: any) => {
            this.depense = depense.content;

            const length = this.collis?.length > this.bagage?.length ? this.collis?.length : this.bagage?.length;
            let heightdoc = 0.3 * ((length) - 2);


            if ((this.collis?.length) < 4){
                heightdoc = 0;
            }
            // console.log('height doc ', heightdoc);
            // doc = new jsPDF((length) > 23 ? 'p' : 'l', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
            doc = new jsPDF('l', 'in',[6, 8.50]) as jsPDFWithPlugin;

            // colis data
            const content: any = [];
            let totalcolis = 0;
            for (let i = 0; i < data.length; i++){
              const rowdata = [];
              // console.log('Content', data[i]);
                for (let index = 0; index < data.length; index++) {
                  rowdata.push((i+1), data[i].ticket,data[i].descriptioncollis, data[i].sender.name, data[i].receiver[0].name, data[i].receiver[0].primarynumber,data[i].tarif,this.datepipe.transform(data[i].creationdate, 'dd-MM-yyyy HH:mm:ss'));
                  totalcolis = totalcolis + data[i].tarif;
                }
                content.push(rowdata);
            }

          // bagage data
            const contentbagage: any = [];
            let totalbagage = 0;
            for (let i = 0; i < this.bagage.length; i++){
              const rowdata = [];
              // console.log('Content', data[i]);
              for (let index = 0; index < this.bagage.length; index++) {
                  rowdata.push(( i + 1), this.bagage[i].idbagage, this.bagage[i].description, this.bagage[i].sendername, this.bagage[i].primaryphone, this.bagage[i].tarif, this.datepipe.transform(this.bagage[i].creationDate, 'dd-MM-yyyy HH:mm:ss'));
                  totalbagage = totalbagage + this.bagage[i].tarif;
                }
              contentbagage.push(rowdata);
            }

            // recette data
            const contentrecette: any = [];
            let totalrecette = 0;
            for (let i = 0; i < this.recette.length; i++){
              const rowdata = [];
              // console.log('Content', data[i]);
              for (let index = 0; index < this.recette.length; index++) {
                  rowdata.push(( i + 1), this.recette[i].idrecette, this.recette[i].description, this.recette[i].sendername, this.recette[i].primarynumber, this.recette[i].tarif, this.datepipe.transform(this.recette[i].creationDate, 'dd-MM-yyyy HH:mm:ss'));
                  totalrecette = totalrecette + this.recette[i].tarif;
                }
              contentrecette.push(rowdata);
            }

            // depense data
            const contentdepense: any = [];
            let totaldepense = 0;
            for (let i = 0; i < this.depense.length; i++){
              const rowdata = [];
              // console.log('Content', data[i]);
              for (let index = 0; index < this.depense.length; index++) {
                  rowdata.push(( i + 1), this.depense[i].idrecette, this.depense[i].description, this.depense[i].sendername, this.depense[i].primarynumber, this.depense[i].tarif, this.datepipe.transform(this.depense[i].creationDate, 'dd-MM-yyyy HH:mm:ss'));
                  totaldepense = Number(totaldepense) + Number(this.depense[i].tarif);
                }
              contentdepense.push(rowdata);
            }

            doc.setFontSize(13);
            doc.setFont("Arial", "bold");
            doc.text("GENERAL EXPRESS VOYAGES", 2.5, 0.27);
            // doc.text('GENERAL EXPRESS VOYAGES', data.settings.margin.left, 22);
            doc.setFontSize(11);
            doc.text("RAPPORT DE FIN DE SESSION" ,2.7, 0.5 );
            doc.setFontSize(9);
            doc.text("Agent:  " + this.name, 1.5, 0.65);
            doc.text("S/N:  " +
            this.sessiondetail.idsessiion +
            "  N° " +
            this.sessiondetail?.sessionCount,
            1.5, 0.83);
            doc.text(
              "Montant:  " + this.sessiondetail?.sessionAmount + " FCFA",
              1.5,
              1
            );
            doc.text(
              "Date d\'impression:  " +
                this.datepipe.transform(
                  new Date(),
                  "dd-MM-yyyy HH:mm:ss"
                ),
                5,
              0.65
            );
            doc.text(
              "Date D\'Ouverture S/N:  " +
                this.datepipe.transform(
                  this.sessiondetail?.creationDate,
                  "dd-MM-yyyy HH:mm:ss"
                ),
              5,
              0.83
            );
            doc.text(
              "Date De Fermeture S/N:  " +
                this.datepipe.transform(
                  this.sessiondetail?.closingDate,
                  "dd-MM-yyyy HH:mm:ss"
                ),
                5,
              1
            );

            // doc.text('Motoboy:  ' + this.bordereauinfo.motoboy.nommb, 5, 0.72);

            const base64Img = this.base64;

            if (base64Img) {
              doc.addImage(this.base64, "JPEG", 0.1, 0, 1, 1);
            }


            doc.autoTable({
              head: [['#', 'N°', 'Nature du Colis', 'Expéditeur', 'Destinataire', 'Telephone', 'Prix', 'Date']],
              body: content,
              showHead: 'firstPage',
              startY: 1.1,
              pageBreak: 'auto',
              rowPageBreak: 'auto',
              horizontalPageBreak: false,
              theme: 'plain',
              avoidPageSplit: true,
              headStyles: {
                fontSize: 12,
                fillColor: '#ffffff',
                fontStyle: 'bold',
                font: 'Arial',
                lineWidth: 0.01,
                lineColor: '#000000',
              },
              styles: {
                overflow: 'ellipsize',
                fontSize: 10,
                font: 'Arial',
                lineWidth: 0.01,
                lineColor: '#000000',
                textColor : '#000000',
              },
              didDrawPage: (data: any) => {
                // // Header

                // // Footer
                // doc.setFontSize(11);
              },
              drawRow: (row: any) => {
                if (row.index > 0 && row.index % 23 === 0) {
                  doc.autoTableAddPage();
                  doc = new jsPDF((this.collis?.length) > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
                }
              }
            });

            this.pageheight = doc.autoTableEndPosY() + 1.01;
            const pageHeightsc = doc.autoTableEndPosY() + 1;

            doc.setFontSize(11);
            doc.text('TOTAL COLIS: ' + (totalcolis / this.collis.length) + ' FCFA', 2, (pageHeightsc - 0.7), {align: 'center'});
                  // doc.setFontSize(10);
                  // doc.text('Visa Agent', 2, (pageHeightsc - 0.5), {align: 'center'});
                  // doc.text(datas.name, 2, (pageHeightsc - 0.2), {align: 'center'});
                  // doc.text('Visa du Chef', 4.2, (pageHeightsc - 0.5), {align: 'center'});

          // bagage table

            if (this.bagage.length > 0) {
              doc.autoTable({
                head: [['#', 'N°', 'Description Bagage', 'Expéditeur', 'Telephone', 'Prix', 'Date']],
                body: contentbagage,
                showHead: 'firstPage',
                startY: this.pageheight,
                pageBreak: 'auto',
                rowPageBreak: 'auto',
                horizontalPageBreak: false,
                theme: 'plain',
                avoidPageSplit: true,
                headStyles: {
                  fontSize: 12,
                  fillColor: '#ffffff',
                  fontStyle: 'bold',
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                },
                styles: {
                  overflow: 'ellipsize',
                  fontSize: 10,
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                  textColor : '#000000',
                },
                didDrawPage: (data: any) => {
                  // // Header
                },
                drawRow: (row: any) => {
                  if (row.index > 0 && row.index % 23 === 0) {
                    doc.autoTableAddPage();
                    doc = new jsPDF((this.bagage.length) > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
                  }
                }
              });

              this.pageheight = doc.autoTableEndPosY() + 1.01;
              const pageHeights2 = doc.autoTableEndPosY() + 1;

              doc.text('TOTAL BAGAGE: ' + (totalbagage / this.bagage.length) + ' FCFA', 2, (pageHeights2 - 0.7), {align: 'center'});
            }

            // recette table

            if (this.recette.length > 0) {
              doc.autoTable({
                head: [['#', 'N°', 'Description Recette', 'Client', 'Telephone', 'Prix', 'Date']],
                body: contentrecette,
                showHead: 'firstPage',
                startY: this.pageheight,
                pageBreak: 'auto',
                theme: 'plain',
                rowPageBreak: 'auto',
                horizontalPageBreak: false,
                avoidPageSplit: true,
                headStyles: {
                  fontSize: 12,
                  fillColor: '#ffffff',
                  fontStyle: 'bold',
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                },
                styles: {
                  overflow: 'ellipsize',
                  fontSize: 10,
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                  textColor : '#000000',
                },
                didDrawPage: (data: any) => {
                  // Header
                },
                drawRow: (row: any) => {
                  if (row.index > 0 && row.index % 23 === 0) {
                    doc.autoTableAddPage();
                    doc = new jsPDF((this.recette.length) > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
                  }
                }
              });
              const pageCount = doc.internal.getNumberOfPages();
              const pageSize = doc.internal.pageSize;
              const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
              this.pageheight = doc.autoTableEndPosY() + 1.01;
              const pageHeights = doc.autoTableEndPosY() + 1;

              doc.setFontSize(11);
              doc.text('TOTAL RECETTE: ' + (totalrecette / this.recette.length) + ' FCFA', 2, (pageHeights - 0.7), {align: 'center'});
            }


            // doc.setFontSize(10);
            // doc.text('Visa Agent', 2, (pageHeights - 0.5), {align: 'center'});
            // doc.text(datas.name, 2, (pageHeights - 0.2), {align: 'center'});
            // doc.text('Visa du Chef', 4.2, (pageHeights - 0.5), {align: 'center'});

            // console.log(pageHeights);

            // depense table
            // let heightdoc2 = 0.3 * ((this.bagage?.length) - 2);
            // if ((this.bagage?.length) < 4){
            //     heightdoc2 = 0;
            // }
            // doc = new jsPDF((this.bagage?.length) > 23 ? 'p' : 'l', 'in', [(3 + heightdoc2), 8.25]) as jsPDFWithPlugin;

            if (this.depense.length > 0) {
              doc.autoTable({
                head: [['#', 'N°', 'Description Depense', 'Client', 'Telephone', 'montant', 'Date']],
                body: contentdepense,
                showHead: 'firstPage',
                startY: this.pageheight,
                pageBreak: 'auto',
                theme: 'plain',
                rowPageBreak: 'auto',
                horizontalPageBreak: false,
                avoidPageSplit: true,
                headStyles: {
                  fontSize: 12,
                  fillColor: '#ffffff',
                  fontStyle: 'bold',
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                },
                styles: {
                  overflow: 'ellipsize',
                  fontSize: 10,
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                  textColor : '#000000',
                },
                didDrawPage: (data: any) => {
                  // Header

                  // doc.setFontSize(20);
                  // doc.setTextColor(40);
                  // // const base64Img = 'data:image/jpeg;base64,' + btoa('../../../../assets/images/logogen.jpg');
                  // // const base64Img = this.base64;

                  // // if (base64Img) {
                  // //   doc.addImage(this.base64, 'JPEG', 6.7, 0, 1, 1);
                  // // }
                  // // doc.text('Report', data.settings.margin.left + 15, 22)

                  // // Footer
                  // doc.setFontSize(11);

                  // // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                  // const pageCount = doc.internal.getNumberOfPages();
                  // const pageSize = doc.internal.pageSize;
                  // const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                  // // const pageHeight = doc.autoTableEndPosY() + 1;
                  // // doc.text('Visa Agent', data.settings.margin.left, pageHeight);
                  // if (doc.internal.getCurrentPageInfo().pageNumber == pageCount) {
                  //   doc.text('TOTAL DEPENSE: ' + (totaldepense / this.depense.length) + ' FCFA', data.settings.margin.right + 2, (pageHeight - 0.7), {align: 'center'});
                  //   doc.setFontSize(10);
                  //   doc.text('Visa Agent', data.settings.margin.right + 2, (pageHeight - 0.5), {align: 'center'});
                  //   doc.text(datas.name, data.settings.margin.right + 2, (pageHeight - 0.2), {align: 'center'});
                  //   doc.text('Visa du Chef', data.settings.margin.right + 4.2, (pageHeight - 0.5), {align: 'center'});
                  // }
                },
                drawRow: (row: any) => {
                  if (row.index > 0 && row.index % 23 === 0) {
                    doc.autoTableAddPage();
                    doc = new jsPDF((this.depense.length) > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
                  }
                }
              });

              const pageCount3 = doc.internal.getNumberOfPages();
            const pageSize3 = doc.internal.pageSize;
            // const pageHeight3 = pageSize.height ? pageSize.height : pageSize.getHeight();
            this.pageheight = doc.autoTableEndPosY() + 1.01;
            const pageHeights3 = doc.autoTableEndPosY() + 1;

            doc.setFontSize(11);
            doc.text('TOTAL DEPENSE: ' + (totaldepense / this.depense.length) + ' FCFA', 2, (pageHeights3 - 0.7), {align: 'center'});

          }
          const pageHeights3 = doc.autoTableEndPosY() + 1;
            doc.setFontSize(10);
            doc.text('Visa de l\'Agent', 2, (pageHeights3 - 0.5), {align: 'center'});
            doc.text(this.name, 2, (pageHeights3 - 0.2), {align: 'center'});
            doc.text('Visa du Chef', 4.2, (pageHeights3 - 0.5), {align: 'center'});

            // console.log(pageHeights3);
      // doc.save('table.pdf');

        doc.autoPrint();
        // This is a key for printing
        doc.output('dataurlnewwindow');
        // end print
        }); // end depense
       }); // end recette
      }); // end bagage
    }); // end colis
    setTimeout(() => {
      // this.print(session);
      localStorage.removeItem('userinfo');
      localStorage.removeItem('token');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('userRole');
      localStorage.removeItem('agenceinso');
      localStorage.removeItem('agence');
      localStorage.removeItem('authority');
      localStorage.removeItem('lastprint');
      localStorage.removeItem('section');
      localStorage.removeItem('voyage');
      this.router.navigateByUrl('login');
      localStorage.removeItem('session');
      }, 700);
  }

  getpassagerSessionSummary(session: any): any {
    console.log(session);
    this.voaygeservice
      .getsessionSummaryDetails(session)
      .subscribe((response: any) => {
        let doc: any;
        doc = new jsPDF("l", "in", [3, 3.5], true) as jsPDFWithPlugin;

        const contentticket: any = [];
        let totalpercu = 0;
        for (let i = 0; i < response.length; i++) {
          const rowdata = [];
          // console.log('Content', data[i]);
          for (let index = 0; index < response.length; index++) {
            rowdata.push(i + 1, response[i][0], response[i][2], response[i][1]);
            totalpercu = Number(totalpercu) + Number(response[i][1]);
          }
          contentticket.push(rowdata);
        }

        doc.setFontSize(10);
        doc.setFont("Arial", "bold");
        doc.text("GENERAL EXPRESS VOYAGES", 0.9, 0.2);
        doc.setFontSize(8);
        doc.text("RAPPORT DE FIN DE SESSION", 1.1, 0.35);




        doc.setFontSize(7);
        doc.text(
          "Date d'impression:  " +
            this.datepipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
          .7,
          0.55
        );
        doc.text("Date D\'Ouverture S/N: " + this.sessiondetail?.creationDate, 0.7, 0.65);
        doc.text("Date De Fermeture S/N: "+ this.sessiondetail?.closingDate, 0.7, 0.75);
        doc.text("Agent: "+ this.name, 0.7, 0.85);

        // doc.text(
        //   "Total: "+ totalpercu / response.length + ' FCFA',
        //   0.2,
        //   2.1
        // );
        doc.text( "Visa " , 1.5,2.8
        );


        const base64Img = this.base64;

        if (base64Img) {
          doc.addImage(this.base64, "JPEG", 0.05, 0.08, 0.5, 0.6, "", "FAST");
        }

        doc.setFont("Arial", "bold");

        doc.autoTable({
          head: [["N°", "Tarif", "Passager", "Total"]],
          body: contentticket,

          showHead: "firstPage",

          startY: 1,

          pageBreak: "avoid",
          theme: 'plain',
          rowPageBreak: "avoid",
          headStyles: {
            fontSize: 9,
            fillColor: "#ffffff",
            fontStyle: "bold",
            font: "Arial",
            halign: "center",
            lineWidth: 0.01,
            lineColor: "#000000",
          },
          styles: {
            overflow: "ellipsize",
            fontSize: 8,
            font: "Arial",
            lineWidth: 0.01,
            halign: "center",
            lineColor: "#000000",
            textColor: "#000000",
          },
          columnStyles: {
            0: { overflow: "ellipsize", columnWidth: .4 },
            1: { overflow: "ellipsize", columnWidth: 0.7 },
            2: { overflow: "ellipsize", columnWidth: 0.7 },
            3: { overflow: "ellipsize", columnWidth: 0.7 },
          },

          didDrawPage: (data: any) => {

            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
          },
        });
        const pageHeights3 = doc.lastAutoTable.finalY + 1;
        doc.setFontSize(11);
        doc.text( "Total: "+ totalpercu/response.length + ' FCFA', 2, (pageHeights3 - 0.7), {align: 'center'});
          doc.output("dataurlnewwindow");
        });
      setTimeout(() => {
      // this.print(session);
      localStorage.removeItem('userinfo');
      localStorage.removeItem('token');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('userRole');
      localStorage.removeItem('agenceinso');
      localStorage.removeItem('agence');
      localStorage.removeItem('authority');
      localStorage.removeItem('lastprint');
      localStorage.removeItem('voyage');
      localStorage.removeItem('section');
      this.router.navigateByUrl('login');
      localStorage.removeItem('session');
      localStorage.clear();
      }, 700);
  }

  getCollisSessionSummary(session: any): any {
    // console.log(session);
    this.collisservice
      .getColisSummarySession(session)
      .subscribe((response: any) => {
        console.log("response ",response);
        let doc: any;
        doc = new jsPDF("l", "in", [6, 8.5], true) as jsPDFWithPlugin;

        const contentticket: any = [];
        let totalpercu = 0;

        this.bagageservice.getbagagesummary(session).subscribe((bagages: any) => {


        for (let i = 0; i < response.length; i++) {
          const rowdata = [];
          // console.log('Content', data[i]);
          for (let index = 0; index < response.length; index++) {
            rowdata.push(i + 1, response[i][0], response[i][2], response[i][1]);
            totalpercu = Number(totalpercu) + Number(response[i][1]);
          }
          contentticket.push(rowdata);
        }

        const contentbagage: any = [];
        let totalbagage = 0;

        for (let i = 0; i < bagages.length; i++) {
          const rowdata = [];
          // console.log('Content', data[i]);
          for (let index = 0; index < bagages.length; index++) {
            rowdata.push(i + 1, bagages[i][0], bagages[i][2], bagages[i][1]);
            totalbagage = Number(totalbagage) + Number(bagages[i][1]);
          }
          contentbagage.push(rowdata);
        }

        this.recetteservice.getrecettesummary(session,"autres recette").subscribe((recette: any) => {

        const contentrecette: any = [];
        let totalrecette = 0;

        for (let i = 0; i < recette.length; i++) {
          const rowdata = [];
          // console.log('Content', data[i]);
          for (let index = 0; index < recette.length; index++) {
            rowdata.push(i + 1, recette[i][0], recette[i][2], recette[i][1]);
            totalrecette = Number(totalrecette) + Number(recette[i][1]);
          }
          contentrecette.push(rowdata);
        }

        this.recetteservice.getrecettesummary(session,"autres depenses").subscribe((depense: any) => {

          const contentdepense: any = [];
          let totaldepense = 0;

          for (let i = 0; i < depense.length; i++) {
            const rowdata = [];
            // console.log('Content', data[i]);
            for (let index = 0; index < depense.length; index++) {
              rowdata.push(i + 1, depense[i][0], depense[i][2], depense[i][1]);
              totaldepense = Number(totaldepense) + Number(depense[i][1]);
            }
            contentdepense.push(rowdata);
          }

         doc.setFontSize(13);
                    doc.setFont("Arial", "bold");
                    doc.text("GENERAL EXPRESS VOYAGES", 2.5, 0.27);
                    // doc.text('GENERAL EXPRESS VOYAGES', data.settings.margin.left, 22);
                    doc.setFontSize(11);
                    doc.text("RAPPORT DE FIN DE SESSION" ,2.7, 0.5 );
                    doc.setFontSize(9);
                    doc.text("Agent:  " + this.name, 1.5, 0.65);
                    doc.text("S/N:  " +
                    this.sessiondetail.idsessiion +
                    "  N° " +
                    this.sessiondetail.sessionCount,
                    1.5, 0.83);
                    doc.text(
                      "Montant Total:  " + this.sessiondetail.sessionAmount + " FCFA",
                      1.5,
                      1
                    );
                    doc.text(
                      "Date d\'impression:  " +
                        this.datepipe.transform(
                          new Date(),
                          "dd-MM-yyyy HH:mm:ss"
                        ),
                        5,
                      0.65
                    );
                    doc.text(
                      "Date D\'Ouverture S/N:  " +
                        this.datepipe.transform(
                          this.sessiondetail.creationDate,
                          "dd-MM-yyyy HH:mm:ss"
                        ),
                      5,
                      0.83
                    );
                    doc.text(
                      "Date De Fermeture S/N:  " +
                        this.datepipe.transform(
                          this.sessiondetail.closingDate,
                          "dd-MM-yyyy HH:mm:ss"
                        ),
                        5,
                      1
                    );

                    // doc.text('Motoboy:  ' + this.bordereauinfo.motoboy.nommb, 5, 0.72);

                    const base64Img = this.base64;

                    if (base64Img) {
                      doc.addImage(this.base64, "JPEG", 0.1, 0, 1, 1);
                    }

        doc.setFont("Arial", "bold");
        doc.text("COLIS" ,1.5, 1.3 );


        doc.autoTable({
          head: [["N°", "Tarif", "Colis", "Total"]],

          body: contentticket,

          showHead: "firstPage",

          startY: 1.4,

          theme: 'plain',
          horizontalPageBreak: false,
          avoidPageSplit: true,
          pageBreak: "auto",
          rowPageBreak: "auto",
          headStyles: {
            fontSize: 9,
            fillColor: "#ffffff",
            fontStyle: "bold",
            font: "Arial",
            halign: "center",
            lineWidth: 0.01,
            lineColor: "#000000",
          },
          styles: {
            overflow: "ellipsize",
            fontSize: 8,
            font: "Arial",
            lineWidth: 0.01,
            halign: "center",
            lineColor: "#000000",
            textColor: "#000000",
          },


          didDrawPage: (data: any) => {

            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
          },
        });
        const pageHeights1 = doc.lastAutoTable.finalY + 1;
        doc.setFontSize(11);
        doc.text( "Total Colis: "+ totalpercu/response.length + ' FCFA', 5.5, (pageHeights1 - 0.7), {align: 'center'});

        if(bagages.length > 0){
          doc.text("BAGAGE" ,1.5, (pageHeights1 - 0.5));

        doc.autoTable({
          head: [["N°", "Tarif", "Bagage", "Total"]],

          body: contentbagage,

          showHead: "firstPage",

          startY: (pageHeights1 - 0.4),

          pageBreak: "auto",
          theme: 'plain',
          rowPageBreak: "auto",
          headStyles: {
            fontSize: 9,
            fillColor: "#ffffff",
            fontStyle: "bold",
            font: "Arial",
            halign: "center",
            lineWidth: 0.01,
            lineColor: "#000000",
          },
          styles: {
            overflow: "ellipsize",
            fontSize: 8,
            font: "Arial",
            lineWidth: 0.01,
            halign: "center",
            lineColor: "#000000",
            textColor: "#000000",
          },
          didDrawPage: (data: any) => {

            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
          },
        });

        this.pageHeights2 = doc.lastAutoTable.finalY + 1;
      doc.setFontSize(11);
      doc.text( "Total Bagage: "+ totalbagage/bagages.length + ' FCFA', 5.5, (this.pageHeights2 - 0.7), {align: 'center'});
        }

    if(recette.length > 0){

      doc.text("AUTRE RECETTE" ,1.5, (this.pageHeights2 - 0.5) );

      doc.autoTable({
        head: [["N°", "Tarif", "Autre Recette", "Total"]],

        body: contentrecette,

        showHead: "firstPage",

        startY: (this.pageHeights2 - 0.4) ,

        pageBreak: "auto",
        theme: 'plain',
        rowPageBreak: "auto",
        headStyles: {
          fontSize: 9,
          fillColor: "#ffffff",
          fontStyle: "bold",
          font: "Arial",
          halign: "center",
          lineWidth: 0.01,
          lineColor: "#000000",
        },
        styles: {
          overflow: "ellipsize",
          fontSize: 8,
          font: "Arial",
          lineWidth: 0.01,
          halign: "center",
          lineColor: "#000000",
          textColor: "#000000",
        },
        didDrawPage: (data: any) => {

          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
        },
      });

      this.pageHeights3 = doc.lastAutoTable.finalY + 1;
    doc.setFontSize(11);
    doc.text( "Total Autre Recette: "+ totalrecette/recette.length + ' FCFA', 5.5, (this.pageHeights3 - 0.7), {align: 'center'});
    }

    if(depense.length > 0) {
      doc.text("DEPENSE" ,1.5, (this.pageHeights3 - 0.5) );

      doc.autoTable({
        head: [["N°", "Tarif", "D\épense", "Total"]],

        body: contentdepense,

        showHead: "firstPage",

        startY: (this.pageHeights3 - 0.4) ,

        pageBreak: "auto",
        theme: 'plain',
        rowPageBreak: "auto",
        headStyles: {
          fontSize: 9,
          fillColor: "#ffffff",
          fontStyle: "bold",
          font: "Arial",
          halign: "center",
          lineWidth: 0.01,
          lineColor: "#000000",
        },
        styles: {
          overflow: "ellipsize",
          fontSize: 8,
          font: "Arial",
          lineWidth: 0.01,
          halign: "center",
          lineColor: "#000000",
          textColor: "#000000",
        },
        didDrawPage: (data: any) => {

          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
        },
      });

      const pageHeights4 = doc.lastAutoTable.finalY + 1;
    doc.setFontSize(11);
    doc.text( "Total D\épense: "+ totaldepense/depense.length + ' FCFA', 5.5, (pageHeights4 - 0.7), {align: 'center'});
    }

    const pageHeights3 = doc.autoTableEndPosY() + 1;
    doc.text( "Montant Total: "+ ((totalpercu/response.length) + (totalbagage/bagages.length > 0?(totalbagage/bagages.length):0) + (totalrecette/recette.length>0?(totalrecette/recette.length):0) + (totaldepense/depense.length >0?(totaldepense/depense.length):0 )) + ' FCFA', 2, (pageHeights3 - 0.55), {align: 'center'});
            doc.setFontSize(11);
            doc.text('Visa de l\'Agent', 2, (pageHeights3 - 0.35), {align: 'center'});
            doc.text(this.name, 2, (pageHeights3 - 0.2), {align: 'center'});
            doc.text('Visa du Chef', 4.2, (pageHeights3 - 0.35), {align: 'center'});

        doc.output("dataurlnewwindow");
      });//depense end
      });//recette end
      });//bagage end
    });//colis end

    setTimeout(() => {
      // this.print(session);
      localStorage.removeItem('userinfo');
      localStorage.removeItem('token');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('userRole');
      localStorage.removeItem('agenceinso');
      localStorage.removeItem('agence');
      localStorage.removeItem('authority');
      localStorage.removeItem('lastprint');
      localStorage.removeItem('section');
      localStorage.removeItem('voyage');
      this.router.navigateByUrl('login');
      localStorage.removeItem('session');
      localStorage.clear();
      }, 700);
  }
}
